import { clsx } from 'clsx';
import { ReactNode } from 'react';
import styles from './IntroductionWidget.module.scss';
import { DocLink } from '../../../docs/DocLink/DocLink';
import { Button, ButtonProps } from '../../../button/Button';

export interface IntroductionWidgetProps {
  dataId: string;
  entity: ReactNode;
  title: ReactNode;
  illustration: ReactNode;
  description: ReactNode;
  docLink?: string;
  hideCaption?: boolean;
  buttonProps?: Partial<ButtonProps>;
}

export function IntroductionWidget({
  dataId,
  entity,
  title,
  description,
  illustration,
  docLink,
  hideCaption = false,
  buttonProps
}: IntroductionWidgetProps) {
  return (
    <div className={styles.introContainer} data-id={dataId}>
      <div className='center-flex-row'>{illustration}</div>

      <div className='center-flex-col justify-center mt-7'>
        {!hideCaption ? (
          <span className='text-primary text-uppercase text-bold'>{entity}</span>
        ) : null}

        <span className={clsx('text-default text-center mt-1 mb-4', styles.titleText)}>
          {title}
        </span>

        <span className={clsx('text-secondary text-center mb-2', styles.bodyText)}>
          {description}
        </span>

        {docLink ? (
          <DocLink dataId={dataId} section={`${entity}-intro-widget`} docLink={docLink} />
        ) : null}

        {buttonProps ? (
          <Button className='mt-6' dataId={dataId} icon='plus' size='lg' {...buttonProps} />
        ) : null}
      </div>
    </div>
  );
}
